import React from 'react';
import { IconBase } from '../Base';
export const IconPlus = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("g", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", d: "M16.6667 5.41663L7.49999 14.5833L3.33333 10.4166", style: { stroke: 'var(--icon-color)' } },
            React.createElement("path", { d: "M15 10L5 10" }),
            React.createElement("path", { d: "M10 15L10 5" }))));
};
//# sourceMappingURL=Plus.js.map